import { hot } from 'react-hot-loader/root';
import Component from './incidentsList-view';

export default hot(Component);
